import * as angular from 'angular';

import { ComponentDefinition, IErrorReporting } from '../../models';

class ValidationErrorsController implements angular.IComponentController {
    isDebug: boolean = false;
    
    readonly fields: IErrorReporting[];
    readonly formController: any;

    static $inject = [];
}

export const wtValidationErrors: ComponentDefinition = {
    componentId: 'wtValidationErrors',
    controller: ValidationErrorsController,
    template: require('./validationErrors.component.html'),
    controllerAs: 'vm',
    bindings: {
        fields: '<',
        formController: '<'
    }
};
